export const shortenString = (str: string, length: number, affix?: string) => {
  if (!str) return '';
  if (str.length <= length) return str;
  return `${str.slice(0, length)}${affix || ''}`;
};

export function humanizeEnum(value: string): string {
  return value
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function capitalizeFirstLetter(
  value: string | null | undefined
): string {
  if (!value || !value.trim()) return '';

  const trimmed = value.trim();
  return trimmed[0].toUpperCase() + trimmed.slice(1);
}
